import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import anc from './converted/anc.rt.yml';
import anc_alt from './converted/anc_alt.rt.yml';
import ancestry_normal from './converted/ancestry_normal.rt.yml';
import ancestry_normal_alt from './converted/ancestry_normal_alt.rt.yml';
import ancestry_percent from './converted/ancestry_percent.rt.yml';
import ancestry_percent_alt from './converted/ancestry_percent_alt.rt.yml';
import attitudes_percent from './converted/attitudes_percent.rt.yml';
import attitudes_percent_alt from './converted/attitudes_percent_alt.rt.yml';
import bat from './converted/bat.rt.yml';
import bat_alt from './converted/bat_alt.rt.yml';
import bdp from './converted/bdp.rt.yml';
import bdp_alt from './converted/bdp_alt.rt.yml';
import bp from './converted/bp.rt.yml';
import bp_alt from './converted/bp_alt.rt.yml';
import c10 from './converted/c10.rt.yml';
import c10_alt from './converted/c10_alt.rt.yml';
import c10b from './converted/c10b.rt.yml';
import c10b_alt from './converted/c10b_alt.rt.yml';
import c10c from './converted/c10c.rt.yml';
import c10c_alt from './converted/c10c_alt.rt.yml';
import census_trend_comparison from './converted/census_trend_comparison.rt.yml';
import census_trend_comparison_alt from './converted/census_trend_comparison_alt.rt.yml';
import cex from './converted/cex.rt.yml';
import cex_alt from './converted/cex_alt.rt.yml';
import crimerisk from './converted/crimerisk.rt.yml';
import crimerisk_alt from './converted/crimerisk_alt.rt.yml';
import crimerisk_normal from './converted/crimerisk_normal.rt.yml';
import crimerisk_normal_alt from './converted/crimerisk_normal_alt.rt.yml';
import crm from './converted/crm.rt.yml';
import crm_alt from './converted/crm_alt.rt.yml';
import cts from './converted/cts.rt.yml';
import cts_alt from './converted/cts_alt.rt.yml';
import cxa from './converted/cxa.rt.yml';
import cxa_alt from './converted/cxa_alt.rt.yml';
import cxf from './converted/cxf.rt.yml';
import cxf_alt from './converted/cxf_alt.rt.yml';
import cxs from './converted/cxs.rt.yml';
import cxs_alt from './converted/cxs_alt.rt.yml';
import cxt from './converted/cxt.rt.yml';
import cxt_alt from './converted/cxt_alt.rt.yml';
import demographic_essentials from './converted/demographic_essentials.rt.yml';
import demographic_essentials_alt from './converted/demographic_essentials_alt.rt.yml';
import dimensions_normal from './converted/dimensions_normal.rt.yml';
import dimensions_normal_alt from './converted/dimensions_normal_alt.rt.yml';
import env from './converted/env.rt.yml';
import env_alt from './converted/env_alt.rt.yml';
import environmental from './converted/environmental.rt.yml';
import environmental_alt from './converted/environmental_alt.rt.yml';
import exs from './converted/exs.rt.yml';
import exs_alt from './converted/exs_alt.rt.yml';
import gp3g from './converted/gp3g.rt.yml';
import gp3g_alt from './converted/gp3g_alt.rt.yml';
import gp4g from './converted/gp4g.rt.yml';
import gp4g_alt from './converted/gp4g_alt.rt.yml';
import gp5 from './converted/gp5.rt.yml';
import gp5_alt from './converted/gp5_alt.rt.yml';
import gp5g from './converted/gp5g.rt.yml';
import gp5g_alt from './converted/gp5g_alt.rt.yml';
import hfx from './converted/hfx.rt.yml';
import hfx_alt from './converted/hfx_alt.rt.yml';
import housing_normal from './converted/housing_normal.rt.yml';
import housing_normal_alt from './converted/housing_normal_alt.rt.yml';
import hp from './converted/hp.rt.yml';
import hp_alt from './converted/hp_alt.rt.yml';
import inc from './converted/inc.rt.yml';
import inc_alt from './converted/inc_alt.rt.yml';
import lab from './converted/lab.rt.yml';
import lab_alt from './converted/lab_alt.rt.yml';
import retail_gap from './converted/retail_gap.rt.yml';
import retail_gap_alt from './converted/retail_gap_alt.rt.yml';
import rtl from './converted/rtl.rt.yml';
import rtl_alt from './converted/rtl_alt.rt.yml';
import xp1 from './converted/xp1.rt.yml';
import xp1_alt from './converted/xp1_alt.rt.yml';
import xp3 from './converted/xp3.rt.yml';
import xp3_alt from './converted/xp3_alt.rt.yml';
import xp5 from './converted/xp5.rt.yml';
import xp5_alt from './converted/xp5_alt.rt.yml';

export const HighPriorityExportReportTemplates: ReadonlyArray<ReportTemplate> = [
  crimerisk,
  cxa,
  cxs,
  exs,
  gp5,
  hp,
  xp5,
  crimerisk_alt,
  cxa_alt,
  cxs_alt,
  exs_alt,
  gp5_alt,
  hp_alt,
  xp5_alt,
];

export const ExportReportTemplates: ReadonlyArray<ReportTemplate> = [
  anc,
  anc_alt,
  ancestry_normal,
  ancestry_normal_alt,
  ancestry_percent,
  ancestry_percent_alt,
  attitudes_percent,
  attitudes_percent_alt,
  bat,
  bat_alt,
  bp,
  bp_alt,
  bdp,
  bdp_alt,
  c10,
  c10_alt,
  c10b,
  c10b_alt,
  c10c,
  c10c_alt,
  census_trend_comparison,
  census_trend_comparison_alt,
  cex,
  cex_alt,
  crimerisk_normal,
  crimerisk_normal_alt,
  crm,
  crm_alt,
  cts,
  cts_alt,
  cxf,
  cxf_alt,
  cxt,
  cxt_alt,
  demographic_essentials,
  demographic_essentials_alt,
  dimensions_normal,
  dimensions_normal_alt,
  env,
  env_alt,
  environmental,
  environmental_alt,
  gp3g,
  gp3g_alt,
  gp4g,
  gp4g_alt,
  gp5g,
  gp5g_alt,
  hfx,
  hfx_alt,
  housing_normal,
  housing_normal_alt,
  inc,
  inc_alt,
  lab,
  lab_alt,
  retail_gap,
  retail_gap_alt,
  rtl,
  rtl_alt,
  xp1,
  xp1_alt,
  xp3,
  xp3_alt,
];
